import { useQuery } from '@tanstack/react-query'
import { fetchUsdToJpyRate } from '@/lib/exchange-rate'

const STALE_MS = 6 * 60 * 60 * 1000 // 6 hours
const GC_MS = 12 * 60 * 60 * 1000 // 12 hours

export function useUsdToJpyRate() {
  return useQuery<number>({
    queryKey: ['exchange-rate', 'usd-jpy'],
    queryFn: fetchUsdToJpyRate,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    retry: 1,
  })
}
